/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AnswerOptionWithAlternates } from './answerOptionWithAlternates';


/**
 * Ответы пользователя с несколькими альтернативными вариантами и файлами.
 */
export interface UserRepliesWithAlternates { 
    /**
     * ID вопроса.
     */
    questionId?: string;
    /**
     * ID варианты ответов (массив для множественного выбора).
     */
    answerOptions?: Array<AnswerOptionWithAlternates>;
}

